import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://centricq.com';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

export default function PageMeta({
  title,
  description,
  path = '',
  image = DEFAULT_IMAGE,
  type = 'website',
  noIndex = false,
  publishedAt,
  modifiedAt,
  author = 'CentricQ',
}) {
  const fullTitle = title ? `${title} | CentricQ` : 'CentricQ — AI-Powered Interview Preparation';
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="CentricQ" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Article-specific */}
      {publishedAt && <meta property="article:published_time" content={publishedAt} />}
      {modifiedAt  && <meta property="article:modified_time"  content={modifiedAt} />}
      {publishedAt && <meta property="article:author" content={author} />}
    </Helmet>
  );
}
